import apiSlice from "state/api/apiSlice";

export const settlementApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getBillingGuidesByCommunityId: builder.query({
      query: (id) => ({
        url: `/communities/${id}/sessions/settlement/billing-guides`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: [{ type: "Files", id: "BillingGuides" }],
    }),

    /* POST */
    downloadBillingGuideByCommunityIdFileName: builder.mutation({
      query: ({ communityId, fileName }) => ({
        url: `/communities/${communityId}/sessions/settlement/billing-guides/${fileName}`,
        method: "POST",
        responseHandler: async (response) => response.blob(),
        cache: "no-cache",
      }),
    }),
    deleteBillingGuideByCommunityIdFileName: builder.mutation({
      query: ({ communityId, fileName }) => ({
        url: `/communities/${communityId}/sessions/settlement/billing-guides/${fileName}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Files", id: "BillingGuides" }],
    }),
    refreshBillingGuidesByCommunityId: builder.mutation({
      query: (id) => ({
        url: `/communities/${id}/sessions/settlement/billing-guides`,
        method: "POST",
      }),
    }),
    generateExcelBillingGuide: builder.mutation({
      query: ({ communityId, startDate, endDate, userIds, sheets, language }) => ({
        url: `/communities/${communityId}/sessions/settlement/billing-guides/excel`,
        method: "POST",
        body: {
          start_date: startDate,
          end_date: endDate,
          user_ids: userIds,
          sheets,
          language,
        },
      }),
    }),
    generatePdfBillingGuide: builder.mutation({
      query: ({ communityId, startDate, endDate, userIds, sheets, language }) => ({
        url: `/communities/${communityId}/sessions/settlement/billing-guides/pdf`,
        method: "POST",
        body: {
          start_date: startDate,
          end_date: endDate,
          user_ids: userIds,
          sheets,
          language,
        },
      }),
    }),
    getSettlementMembersKPIsByCommunityId: builder.query({
      query: ({ communityId, startDate, endDate }) => ({
        url:
          `/communities/${communityId}/sessions/settlement/settlement-kpis?` +
          `start_date=${startDate}&` +
          `end_date=${endDate}&`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: [{ type: "Settlement", id: "settlement-kpis" }],
    }),
    getSettlementMembersMetricsByCommunityId: builder.query({
      query: ({ communityId, startDate, endDate }) => ({
        url:
          `/communities/${communityId}/sessions/settlement/settlement-metrics?` +
          `start_date=${startDate}&` +
          `end_date=${endDate}&`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: [{ type: "Settlement", id: "settlement-kpis" }],
    }),
  }),
});

export const {
  useGetBillingGuidesByCommunityIdQuery,
  useRefreshBillingGuidesByCommunityIdMutation,
  useGenerateExcelBillingGuideMutation,
  useGeneratePdfBillingGuideMutation,
  useGetSettlementMembersKPIsByCommunityIdQuery,
  useGetSettlementMembersMetricsByCommunityIdQuery,
  useDownloadBillingGuideByCommunityIdFileNameMutation,
  useDeleteBillingGuideByCommunityIdFileNameMutation,
} = settlementApiSlice;
